(() => {
  const leadKey = 'procards-private-sale-lead-v1';
  const formId = 'forms-root-1176087';

  function whatsappUrl(lead) {
    const message = [
      'Hola Procards Sports, quiero coordinar la compra de una carta de alto valor.',
      `Carta: ${lead.cardName}`,
      `Enlace: ${lead.cardUrl}`,
      `Nombre: ${lead.firstName}`,
      `Apellido: ${lead.lastName}`,
      `Correo: ${lead.email}`,
      `Teléfono: ${lead.phone}`,
      `Dirección: ${lead.address}`,
      `Comuna: ${lead.commune}`,
      'Solicito atención de un ejecutivo para concretar la venta.',
    ].join('\n');
    return `https://wa.me/56968303948?text=${encodeURIComponent(message)}`;
  }

  function setNativeValue(input, value) {
    if (!input || input.value === value) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function styleNativeForm(shadow) {
    if (shadow.querySelector('[data-pc-form-style]')) return;
    const style = document.createElement('style');
    style.dataset.pcFormStyle = '';
    style.textContent = `
      :host {
        --forms-body-font: 400 14px var(--font-body-family);
        --forms-heading-font: 400 22px var(--font-heading-family);
        --body-text-color: #f3f3f0;
        --heading-text-color: #f3f3f0;
        --form-text-color: #f3f3f0;
        --form-placeholder-color: #a5a5a1;
        --form-background-color: #111212;
        --link-text-color: #c5a46c;
        --button-background-color: #c5a46c;
        --button-text-color: #111;
      }
      #app-embed, #form-container-ref, section, [role="dialog"] {
        background: transparent !important;
        box-shadow: none !important;
      }
      #app-embed, [role="dialog"] { padding: 0 !important; }
      [role="dialog"] { border: 0 !important; max-width: none !important; }
      [class*="_formHeader_"] { margin: 0 0 20px !important; text-align: left !important; }
      [class*="_formHeader_"] h2 {
        color: #c5a46c !important;
        font: 600 11px var(--font-body-family) !important;
        letter-spacing: .08em !important;
        text-transform: uppercase !important;
      }
      [class*="_formHeader_"] p { color: #a5a5a1 !important; font: 400 13px var(--font-body-family) !important; }
      [data-testid="form"] {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 16px !important;
      }
      [data-testid="form"] > div { min-width: 0 !important; margin: 0 !important; }
      [data-testid="form"] > div:has(shop-lead-capture) { position: absolute !important; }
      [data-testid="form"] input {
        background: #111212 !important;
        border: 1px solid #585a56 !important;
        border-radius: 0 !important;
        color: #f3f3f0 !important;
        font-family: var(--font-body-family) !important;
      }
      [data-testid="form"] label { color: #c6c6c2 !important; font-family: var(--font-body-family) !important; }
      [data-testid="form"] button[type="submit"] {
        grid-column: 1 / -1 !important;
        width: 100% !important;
        min-height: 52px !important;
        margin: 8px 0 0 !important;
        border: 1px solid #c5a46c !important;
        border-radius: 0 !important;
        background: #c5a46c !important;
        color: #111 !important;
        font: 600 14px var(--font-body-family) !important;
      }
      [class*="_formDisclaimer_"] { margin: 18px 0 0 !important; text-align: left !important; }
      [class*="_formDisclaimer_"] p { color: #a5a5a1 !important; font: 400 12px var(--font-body-family) !important; }
      @media (max-width: 749px) { [data-testid="form"] { grid-template-columns: 1fr !important; } }
    `;
    shadow.appendChild(style);
  }

  function init(root) {
    if (root.dataset.pcInitialized) return;
    root.dataset.pcInitialized = 'true';

    const params = new URLSearchParams(window.location.search);
    const handle = params.get('producto');
    const variantId = params.get('variante');
    const nameNode = root.querySelector('[data-pc-card-name]');
    const linkNode = root.querySelector('[data-pc-card-link]');
    const imageNode = root.querySelector('[data-pc-card-image]');
    const imageFallback = root.querySelector('[data-pc-image-fallback]');
    const statusNode = root.querySelector('[data-pc-status]');
    const nativeContainer = root.querySelector('[data-pc-native-form]');
    let selectedCard;

    if (params.get('guardado') === '1') {
      let lead;
      try {
        lead = JSON.parse(sessionStorage.getItem(leadKey) || 'null');
        sessionStorage.removeItem(leadKey);
      } catch (_) { /* Storage may be unavailable. */ }
      if (lead && Date.now() - lead.createdAt < 15 * 60 * 1000 && lead.cardUrl) {
        const url = whatsappUrl(lead);
        statusNode.textContent = 'Solicitud guardada. Abriendo WhatsApp… ';
        const link = document.createElement('a');
        link.className = 'pc-private__fallback-link';
        link.href = url;
        link.textContent = 'Abrir WhatsApp';
        statusNode.appendChild(link);
        window.location.replace(url);
      } else {
        statusNode.textContent = 'La solicitud se guardó, pero no pudimos preparar el mensaje de WhatsApp. Contacta a Procards Sports al +56 9 6830 3948.';
      }
      return;
    }

    if (!handle || !/^[a-z0-9-]+$/.test(handle)) {
      nameNode.textContent = 'No se seleccionó una carta.';
      statusNode.textContent = 'Vuelve a la ficha de la carta y elige «Coordinar compra por WhatsApp».';
      return;
    }

    function connectNativeForm() {
      const host = nativeContainer.querySelector(`[data-forms-id="${formId}"] shopify-forms-embed`);
      const shadow = host?.shadowRoot;
      const form = shadow?.querySelector('[data-testid="form"]');
      if (!form || !selectedCard) return false;

      styleNativeForm(shadow);
      const cardInput = shadow.getElementById('custom#enlace_de_la_carta');
      setNativeValue(cardInput, selectedCard.url);
      if (cardInput) {
        const cardField = cardInput.closest('[class*="_formFieldContainer_"]');
        if (cardField) cardField.style.display = 'none';
      }

      if (!form.dataset.pcLeadCapture) {
        form.dataset.pcLeadCapture = 'true';
        form.addEventListener('submit', () => {
          const field = (id) => shadow.getElementById(id)?.value.trim() || '';
          const lead = {
            createdAt: Date.now(),
            cardName: selectedCard.name,
            cardUrl: selectedCard.url,
            firstName: field('first_name'),
            lastName: field('last_name'),
            email: field('email'),
            phone: field('phone_number'),
            address: field('custom#direccin'),
            commune: field('custom#comuna'),
          };
          try {
            sessionStorage.setItem(leadKey, JSON.stringify(lead));
          } catch (_) {
            statusNode.textContent = 'No pudimos preparar WhatsApp en este navegador. Inténtalo de nuevo con el almacenamiento del sitio habilitado.';
          }
        }, { capture: true });
      }
      return true;
    }

    fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('product_unavailable');
        return response.json();
      })
      .then((product) => {
        const variant = variantId
          ? product.variants.find((entry) => String(entry.id) === variantId)
          : product.variants[0];
        if (!variant || !variant.available) throw new Error('product_unavailable');
        const url = new URL(`/products/${encodeURIComponent(product.handle)}`, window.location.origin);
        url.searchParams.set('variant', variant.id);
        selectedCard = {
          name: product.title + (variant.title && variant.title !== 'Default Title' ? ` · ${variant.title}` : ''),
          url: url.href,
        };
        nameNode.textContent = selectedCard.name;
        linkNode.href = selectedCard.url;
        linkNode.hidden = false;
        const image = variant.featured_image?.src || product.featured_image || product.images?.[0];
        if (typeof image === 'string' && image) {
          imageNode.src = image;
          imageNode.alt = `Carta seleccionada: ${selectedCard.name}`;
          imageNode.hidden = false;
          imageFallback.hidden = true;
          imageNode.addEventListener('error', () => {
            imageNode.hidden = true;
            imageFallback.hidden = false;
          }, { once: true });
        }

        if (!nativeContainer.querySelector(`[data-forms-id="${formId}"]`)) {
          statusNode.textContent = 'El formulario de solicitud no está disponible. Vuelve a intentarlo en unos minutos.';
          return;
        }
        nativeContainer.hidden = false;
        if (connectNativeForm()) return;
        let attempts = 0;
        const timer = window.setInterval(() => {
          attempts += 1;
          if (connectNativeForm() || attempts >= 60) {
            window.clearInterval(timer);
            if (attempts >= 60) statusNode.textContent = 'El formulario no terminó de cargar. Actualiza la página e inténtalo nuevamente.';
          }
        }, 250);
      })
      .catch(() => {
        nameNode.textContent = 'No pudimos cargar esta carta.';
        statusNode.textContent = 'Vuelve a la ficha y comprueba que siga disponible.';
      });
  }

  function initAll() {
    document.querySelectorAll('[data-pc-high-value-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
